import { ProfessionEnum } from 'src/shared/features/users/schemas/profession'

export enum EnterpriseRole {
  OWNER = 'owner',
  ADMIN = 'admin',
  ACCOUNTING = 'accounting',
  MEMBER = 'member',
}

export const enterpriseRoleMap = {
  [EnterpriseRole.OWNER]: 'Owner',
  [EnterpriseRole.ADMIN]: 'Admin',
  [EnterpriseRole.ACCOUNTING]: 'Accounting',
  [EnterpriseRole.MEMBER]: 'Member',
}

export enum EnterpriseInvitationStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  EXPIRED = 'expired',
  CANCELED = 'canceled',
}

export enum EnterpriseType {
  REAL_ESTATE_BROKERAGE = 'real-estate-brokerage',
  MORTGAGE_LENDER = 'mortgage-lender',
  MORTGAGE_BROKERAGE = 'mortgage-brokerage',
  AMC = 'amc',
  INSURANCE_BROKERAGE = 'insurance-brokerage',
  TITLE_COMPANY = 'title-company',
}

export enum SubscriptionStatus {
  TRIALING = 'trialing',
  ACTIVE = 'active',
  EXPIRED = 'expired',
  IN_GRACE_PERIOD = 'in_grace_period',
  IN_BILLING_RETRY = 'in_billing_retry',
  PAUSED = 'paused',
  UNKNOWN = 'unknown',
  INCOMPLETE = 'incomplete',
}

export interface EnterpriseDetailResponse {
  id: number
  enterpriseUrl: string | null
  name: string
  billingEmail: string | null
  subscriptionId: string | null
  totalSeats: number
  totalSpendingLimit: number
  subscriptionStatus: SubscriptionStatus
  position: string
  companySize: string
  companyType: string
  primaryFocus?: string[] | null
  logoPicture?: string | null
}

export enum PaymentStatus {
  Free = 'free',
  PaidByEnterprise = 'paid_by_enterprise',
  PaidByUser = 'paid_by_user',
}

export interface EnterpriseMembershipResponse {
  id: number
  enterpriseId: number
  userId: number
  role: EnterpriseRole
  spendingLimit: number | null
  isActive: boolean
  createdAt: string
  fullName?: string | null
  email?: string | null
  profilePhoto?: string | null
  battery?: number | null
  spending?: number | null
  paymentStatus?: PaymentStatus | null
  enterpriseName?: string | null
  enterpriseType?: string | null
  enterpriseLogoPicture?: string | null
}

export interface MemberRemoveResponse {
  success: boolean
  message: string
  removedAt: string
}

export interface EnterpriseInvitation {
  id: number
  enterprise_id: number
  inviter_id: number
  invitee_id: number | null
  status: EnterpriseInvitationStatus
  email: string
  role: EnterpriseRole
  created_at: string // ISO date string
  updated_at: string | null // ISO date string or null
}

export const enterpriseTypeMap = {
  'real-estate-brokerage': 'Real estate brokerage',
  'mortgage-lender': 'Mortgage lender',
  'mortgage-brokerage': 'Mortgage brokerage',
  amc: 'AMC',
  'insurance-brokerage': 'Insurance brokerage',
  'title-company': 'Title company',
}

export const enterpriseTypeToProfessionMap = {
  'real-estate-brokerage': ProfessionEnum.REAL_ESTATE_AGENT,
  'mortgage-lender': ProfessionEnum.MORTGAGE_LOAN_OFFICER,
  'mortgage-brokerage': ProfessionEnum.MORTGAGE_LOAN_OFFICER,
  amc: ProfessionEnum.REAL_ESTATE_APPRAISER,
  'insurance-brokerage': ProfessionEnum.REAL_ESTATE_INSURANCE_BROKER,
  'title-company': ProfessionEnum.TITLE_COMPANY_REP,
}
